import { BagScannedPage } from '@/pages/bag-scanned';
import { createFileRoute } from '@tanstack/react-router';
import { MaterialType } from '../../../../backend/src/types.generated';

export const Route = createFileRoute('/_app/bag-scanned')({
	component: BagScannedPage,
	validateSearch: (search) => {
		return {
			material: (search?.material as MaterialType) || null,
		};
	},
});
